import { createFileRoute } from "@tanstack/react-router";
import { LandingPage } from "@/lib/lazyPages";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/lp/$slug")({
  // Campaign landing pages duplicate evergreen content — keep them out of search.
  head: () => seoHead({ noindex: true }),
  component: LandingPage,
});
